import { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import {
  getActivationLockBypassCode,
  clearActivationLockBypassCode,
} from "../../commands/mdmCommands";

function formatWhen(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleString("de-DE");
}

function ActivationLockBypassModal({ visible, device, hideModal, onIssued }) {
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
    hideModal();
  };

  useEffect(() => {
    setShow(visible);
  }, [visible]);

  const bypass = device?.activationLockBypassCode;

  async function issue(fn) {
    await fn();
    onIssued?.();
  }

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Activation-Lock-Bypass</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Der Bypass-Code kann nach einem Wipe den Activation Lock umgehen, ohne die
          Apple-ID. Apple stellt ihn nur für betreute Geräte bereit und nur innerhalb
          von 15 Tagen nach der Supervision.
        </p>
        {bypass?.code ? (
          <div className="alert alert-warning">
            <div className="fw-bold font-monospace">{bypass.code}</div>
            {bypass.retrievedAt ? (
              <div className="small mt-1">abgerufen {formatWhen(bypass.retrievedAt)}</div>
            ) : null}
          </div>
        ) : (
          <p className="text-muted">Noch kein Code gespeichert.</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Schließen
        </Button>
        {bypass?.code ? (
          <Button
            variant="outline-danger"
            onClick={() => issue(() => clearActivationLockBypassCode(device.UDID))}
          >
            Code löschen
          </Button>
        ) : null}
        <Button variant="primary" onClick={() => issue(() => getActivationLockBypassCode(device.UDID))}>
          Code holen
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ActivationLockBypassModal;
